import { Link } from 'react-router-dom'
import { AldapaLogo } from '../brand/AldapaLogo'

const groups = [
  { title: 'Software', links: [['Engineering Environment', '/app'], ['AML guide', '/software/aml'], ['System Model guide', '/software/system-models'], ['AldapaNuCore', '/software/aldapanucore'], ['NuSpectra', '/software/nuspectra'], ['Documentation', '/docs']] },
  { title: 'Technology', links: [['Microreactors', '/technology/microreactors'], ['Nuclear batteries', '/technology/nuclear-batteries'], ['Energy conversion', '/technology/energy-conversion'], ['Research', '/technology/research']] },
  { title: 'Company', links: [['About', '/about'], ['Investors', '/investors'], ['Investor materials', '/investors/materials'], ['Careers', '/careers'], ['Contact', '/contact']] },
  { title: 'Resources', links: [['Engineering', '/engineering'], ['Documentation', '/docs'], ['References', '/about'], ['Support', '/contact']] },
  { title: 'Shop', links: [['Apparel', '/shop'], ['Stickers', '/shop'], ['Accessories', '/shop']] },
]

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <Link to="/" aria-label="Aldapa Systems home"><AldapaLogo /></Link>
          <p>Advanced systems for a more capable future.</p>
          <Link className="footer-contact" to="/contact">Get in touch ↗</Link>
        </div>
        {groups.map((group) => <div className="footer-group" key={group.title}><h3>{group.title}</h3>{group.links.map(([label, path]) => <Link key={label} to={path}>{label}</Link>)}</div>)}
      </div>
      <div className="container footer-bottom"><span>© 2026 Aldapa Systems. All rights reserved.</span><div><Link to="/legal/privacy">Privacy</Link><Link to="/legal/terms">Terms</Link><Link to="/legal/security">Security</Link></div></div>
    </footer>
  )
}
